import * as authService from './services/auth';
import * as cartService from './services/cart';
import * as catalogService from './services/catalog';
import * as certificateService from './services/certificate';
import * as checkoutService from './services/checkout';
import * as customerService from './services/customer';
import * as orderService from './services/order';
import * as wishlistService from './services/wishlist';

export {
  authService,
  cartService,
  catalogService,
  wishlistService,
  checkoutService,
  customerService,
  orderService,
  certificateService
};

export * from './__generated__';
export * from './__generated__/graphql';

export * from './types';
export * from './lib/execute';
export * from './lib/types';
export * from './lib/session';
export * from './lib/cookie';
export { default as getCustomerDiagnosticResultsQuery } from './lib/query/getCustomerDiagnosticResults';

export * from './services/customer';
export * from './services/product';
export * from './services/dictionary';
export * from './services/wishlist';
export type { AvailablePromoCode } from './__generated__/graphql';
